import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpecialDayList } from '../../../Pages/Pricing/IPricing';

export const AddSpecialDaySlicer = createSlice({
  name: 'AddSpecialDay',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISpecialDayList>,
  reducers: {
    addSpecialDay: (state, _) => {
      state.isLoading = true;
    },
    successAddSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddSpecialDayState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSpecialDay,
  failureAddSpecialDay,
  successAddSpecialDay,
  clearAddSpecialDayState,
} = AddSpecialDaySlicer.actions;

export default AddSpecialDaySlicer.reducer;
